import { IconBuildings } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getSellerNameColumn(): MRT_ColumnDef<PPAInvoice> {
  return {
    accessorKey: "seller_name",
    header: "Lieferant",
    enableCellHoverReveal: true,
    filterVariant: "multi-select",
    Cell: ({ renderedCellValue }) => (
      <MantineIconCell
        IconComponent={IconBuildings}
        renderedCellValue={renderedCellValue}
      />
    )
  };
}
